import { TechTuningCaseType } from '~/shared';
import caseDotBlue from '../../assets/images/case_dot_blue.png';
import caseDotGreen from '../../assets/images/case_dot_green.png';
import caseDotYellow from '../../assets/images/case_dot_yellow.png';
import diamond from '../../assets/images/diamond.png';
import maximum from '../../assets/images/maximum.png';
import standard from '../../assets/images/standart.png';

export const caseImages = {
	[TechTuningCaseType.STANDART]: standard,
	[TechTuningCaseType.DIAMOND]: diamond,
	[TechTuningCaseType.MAXIMUM]: maximum,
};

export const caseColors = {
	[TechTuningCaseType.STANDART]: '#2D70DA',
	[TechTuningCaseType.DIAMOND]: '#00FFA6',
	[TechTuningCaseType.MAXIMUM]: '#FFC300',
};

export const caseDecDotsImages = {
	[TechTuningCaseType.STANDART]: caseDotBlue,
	[TechTuningCaseType.DIAMOND]: caseDotGreen,
	[TechTuningCaseType.MAXIMUM]: caseDotYellow,
};

export const caseAppearDelay = {
	[TechTuningCaseType.STANDART]: 0.35,
	[TechTuningCaseType.DIAMOND]: 0.4,
	[TechTuningCaseType.MAXIMUM]: 0.45,
};
